export default __webpack_public_path__ + "static/media/black_and_white_birch_with_eyes.28830231.jpg";